import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateUserLocalTimeZoneDataParams {
  offset: number;
  timeZoneId: string;
  isUserSetTimeZone: boolean;
  userId?: string;
}

export class UpdateUserLocalTimeZoneDataRequest extends Request<IUpdateUserLocalTimeZoneDataParams, IResult> {
  constructor(params: IUpdateUserLocalTimeZoneDataParams) {
    super('updateUserLocalTimeZoneData', params);
  }
}
